import React, { useState, useEffect, useRef } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

interface Props {
  value?: string;
  initialValue?: string;
  isEditable: boolean;
  onChange: (html: string) => void;
}

const RichTextEditor: React.FC<Props> = ({
  value,
  initialValue,
  isEditable,
  onChange,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  
  const isInternalChange = useRef(false);
  const prevValueRef = useRef<string>("");
  useEffect(() => {
    const contentToLoad = value || initialValue || "";
    if (contentToLoad && !prevValueRef.current) {
      const contentBlock = htmlToDraft(contentToLoad);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
        );
        setEditorState(EditorState.createWithContent(contentState));
        prevValueRef.current = contentToLoad;
      }
    }
  }, []);

  useEffect(() => {
    const currentValue = value || initialValue || "";
    if (isInternalChange.current) {
      isInternalChange.current = false;
      return;
    }
    if (currentValue && currentValue !== prevValueRef.current) {
      const contentBlock = htmlToDraft(currentValue);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
        );
        setEditorState(EditorState.createWithContent(contentState));
        prevValueRef.current = currentValue;
      }
    }
  }, [value, initialValue]);

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
    isInternalChange.current = true;
    
    const rawContentState = convertToRaw(state.getCurrentContent());
    const html = draftToHtml(rawContentState);
    onChange(html);
  };

  return (
    <div className="custom-editor-wrapper">
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName border rounded-3 p-3"
        editorClassName="editorClassName"
        onEditorStateChange={handleEditorChange}
        readOnly={!isEditable}
        toolbarHidden={!isEditable}
      />
    </div>
  );
};

export default RichTextEditor;